export const shouldShowError = (
    isErrorVisible: boolean,
    touched: boolean,
    errorMessage?: string,
    showErrorBeforeBlur = false,
    dirty = false,
): boolean => {
    const hasInteracted = showErrorBeforeBlur ? touched || dirty : touched;

    return isErrorVisible && hasInteracted && !!errorMessage;
};
